import { cn } from "utils";
import { useMemo } from "react";
import { TWelcomeProps } from "./types";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/invite/Welcome";

const I18n = I18nUtil.createScoped(Translations);

export const Welcome = (props: TWelcomeProps) => {
  const { inviter, isLoggedIn, onClickNextStep } = props;

  const topText = I18n.t(" invites you to join Aura");

  const text = useMemo(() => {
    if (isLoggedIn) {
      return I18n.t("Welcome Back, Aura Champion");
    }
    return I18n.t(
      "You've been chosen. Time to turn those insights into pure power.",
    );
  }, [isLoggedIn]);

  return (
    <div className="w-full h-full flex flex-col items-center max-w-[1013px] text-center md:justify-center">
      <div className="flex-1 flex flex-col items-center justify-center md:flex-none">
        <div
          className={cn(
            "w-full flex flex-row justify-center items-center gap-[4px]",
            { hidden: !inviter || isLoggedIn },
          )}
        >
          <span className="body_l text-content_primary">
            <span className="title_l">{inviter?.handle}</span>
            {topText}
          </span>
        </div>
        <span
          className={cn(
            "mx-[21px] mt-6 text-center md:mx-0 headline_regular_l bg-gradient-to-r from-background_brand_overlay100 via-[#C1ECFF] to-[#3E9EFF] bg-clip-text text-transparent md:display_m md:mt-0",
            { "min-h-[130px]": !isLoggedIn },
          )}
        >
          {text}
        </span>
        <span
          className={cn(
            "body_medium_m text-content_tertiary mt-[8px] max-w-[765px] hidden",
            { block: isLoggedIn },
          )}
        >
          {I18n.t(
            "Let's get your Aura flowing, sharpen Edgen's brain, climb that leaderboard, and stack up serious rewards.",
          )}
        </span>
      </div>
      <button
        type="button"
        data-openreplay-label={`Welcome · Button | ${isLoggedIn ? "Get Started" : "Accept Invite"}`}
        className={cn(
          "button md_button primary_button button_m w-full max-w-[361px] mb-4 md:mt-8",
        )}
        onClick={onClickNextStep}
      >
        {isLoggedIn ? "Get Started" : "Accept Invite"}
      </button>
    </div>
  );
};
